import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/styles/Popularpropertytypes.css";
import analyticsService from "../../services/analyticsService";

// If you have LeftNav / TopNav, keep these imports; otherwise remove them.
import LeftNav from "../components/common/LeftNav";
import TopNav from "../components/common/TopNav";

import BookingIcon from "../assets/img/Booklead.svg";
import Searchh from "../assets/img/Searchh.svg";
import TotalVilla from "../assets/img/TotalVilla.svg";
import LeadIcon from "../assets/img/registerlead.svg";

import Villa from "../assets/img/Villa11.svg";
import Apartment from "../assets/img/Apartment11.svg";
import PlotIcon from "../assets/img/Plot11.svg";
import Commercial from "../assets/img/commercial11.svg";
import arrowleftt from "../assets/img/arrowleftt.svg"

// Property type icon mapping (matches React Native app)
const PROPERTY_TYPE_ICONS = {
  residential: Villa,
  commercial: Commercial,
  industrial: Commercial,
  agricultural: PlotIcon,
  plot: PlotIcon,
  villa: Villa,
  apartment: Apartment,
};

export default function PopularPropertyTypes() {
  const navigate = useNavigate();
  // EXACT React Native app state structure
  const [loading, setLoading] = useState(true);
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [states, setStates] = useState([]);
  const [citiesByState, setCitiesByState] = useState({});
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => { loadInitialData(); }, []);

  const loadInitialData = async () => {
    try {
      setLoading(true);
      const citiesStatesResponse = await analyticsService.getCitiesAndStates();
      if (citiesStatesResponse.success && citiesStatesResponse.data) {
        setStates([...new Set((citiesStatesResponse.data.states || []).map(s => s.replace(/\s+\d{5,6}\s*$/, '').trim()))].sort());
        setCitiesByState(citiesStatesResponse.data.citiesByState || {});
      }
      await loadPropertyTypes();
    } catch (error) {
      console.error('Error loading initial data:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadPropertyTypes = async (pageNum = 1) => {
    try {
      const filters = { page: pageNum, per_page: 20 };
      if (selectedCity) filters.city = selectedCity;
      if (selectedState) filters.state = selectedState;

      const response = await analyticsService.getPopularPropertyTypes(filters);

      if (response.success && response.data) {
        setPropertyTypes(response.data.items || []);
        setTotal(response.data.total || 0);
        setTotalPages(response.data.total_pages || 1);
        setPage(pageNum);
      } else {
        setPropertyTypes([]);
        setTotal(0);
        setTotalPages(1);
        setPage(1);
      }
    } catch (error) {
      console.error('Error loading property types:', error);
      setPropertyTypes([]);
      setTotal(0);
      setTotalPages(1);
    }
  };

  const handleApply = async () => {
    setLoading(true);
    setPage(1); // Reset to first page when applying filters
    await loadPropertyTypes(1);
    setLoading(false);
  };

  const handleStateChange = (e) => { setSelectedState(e.target.value); setSelectedCity(''); };
  const handleCityChange = (e) => { setSelectedCity(e.target.value); };
  const getFilteredCities = () => !selectedState ? [] : (citiesByState[selectedState] || []);

  // Format property type name (matches React Native app)
  const formatTypeName = (type) => {
    if (!type) return 'Unknown';
    return type.charAt(0).toUpperCase() + type.slice(1);
  };

  // Get property type icon (matches React Native app)
  const getTypeIcon = (type) => {
    return PROPERTY_TYPE_ICONS[type?.toLowerCase()] || Villa;
  };

  return (
    <div className="ppt-page d-flex">
      <LeftNav />

      <div className="ppt-content-wrap flex-grow-1">
        <TopNav />

        <div className="container-fluid">
          <div className="ppt-card card ppt-container-card mt-3">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start ppt-header-row">
                <div className="d-flex align-items-center gap-2 ppt-header-left">
                  <img src={arrowleftt} onClick={() => navigate("/webadmindashboard")} style={{cursor: "pointer"}}></img>
                  <h2 className="ppt-page-title mb-0">Popular Property Types</h2>
                </div>

                <div className="d-flex gap-2 align-items-end ppt-filters">
                  <div className="d-flex flex-column">
                    <label className="ppt-label">State</label>
                    <select
                      className="form-select form-select-sm ppt-select"
                      value={selectedState}
                      onChange={handleStateChange}
                      disabled={loading}
                    >
                      <option value="">Select State</option>
                      {Array.isArray(states) ? states.map((state, idx) => (
                        <option key={idx} value={state}>{state}</option>
                      )) : []}
                    </select>
                  </div>

                  {selectedState && (
                    <div className="d-flex flex-column">
                      <label className="ppt-label">City</label>
                      <select
                        className="form-select form-select-sm ppt-select"
                        value={selectedCity}
                        onChange={handleCityChange}
                        disabled={loading}
                      >
                        <option value="">Select City</option>
                        {getFilteredCities().map((city, idx) => (
                          <option key={idx} value={city}>{city}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  <button
                    className="btn btn-primary ppt-apply-btn"
                    onClick={handleApply}
                    disabled={loading}
                  >
                    {loading ? 'Loading...' : 'Apply'}
                  </button>
                </div>
              </div>

              {/* Loading State */}
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <div className="mt-3" style={{ color: '#888' }}>Loading...</div>
                </div>
              ) : propertyTypes.length === 0 ? (
                <div className="ppt-empty-container">
                  <p>No property types found</p>
                  <button onClick={handleApply} className="ppt-retry-btn">Retry</button>
                </div>
              ) : (
                <>
                  {/* grid: two columns */}
                  <div className="ppt-grid mt-3">
                    {propertyTypes.map((propType, idx) => {
                      const typeName = formatTypeName(propType.property_type);
                      const rank = (page - 1) * 20 + idx + 1;

                      return (
                        <div key={`${propType.property_type}-${idx}`} className="ppt-item-card card">
                          <div className="card-body ppt-item-body">
                            <div className="d-flex">
                              <div className="ppt-main flex-grow-1">
                                <div className="d-flex justify-content-between align-items-start">
                                  <div className="ppt-title d-flex align-items-center">
                                    <span className="ppt-type">{rank} Property Type:</span>
                                    <span className="ppt-type-name ms-1">{typeName}</span>
                                    {/* show icon based on property type */}
                                    <img src={getTypeIcon(propType.property_type)} alt={typeName} className="ppt-type-icon ms-2" />
                                  </div>
                                </div>

                                <div className="ppt-borderline"></div>

                                {/* 2x2 stats grid */}
                                <ul className="ppt-meta-grid list-unstyled mb-0">
                                  <li className="ppt-meta-cell">
                                    <div className="ppt-meta-left">
                                      <img src={BookingIcon} alt="Bookings" className="ppt-meta-icon" />
                                      <span className="ppt-meta-text">Total Bookings:</span>
                                    </div>
                                    <div className="ppt-meta-right">
                                      <span className="ppt-meta-value">{propType.total_bookings || 0}</span>
                                    </div>
                                  </li>

                                  <li className="ppt-meta-cell">
                                    <div className="ppt-meta-left">
                                      <img src={Searchh} alt="Searches" className="ppt-meta-icon" />
                                      <span className="ppt-meta-text">Searches:</span>
                                    </div>
                                    <div className="ppt-meta-right">
                                      <span className="ppt-meta-value">{propType.searches || 0}</span>
                                    </div>
                                  </li>

                                  <li className="ppt-meta-cell">
                                    <div className="ppt-meta-left">
                                      <img src={TotalVilla} alt="Projects" className="ppt-meta-icon" />
                                      <span className="ppt-meta-text">Total {typeName} Projects:</span>
                                    </div>
                                    <div className="ppt-meta-right">
                                      <span className="ppt-meta-value">{propType.total_projects || 0}</span>
                                    </div>
                                  </li>

                                  <li className="ppt-meta-cell">
                                    <div className="ppt-meta-left">
                                      <img src={LeadIcon} alt="Leads" className="ppt-meta-icon" />
                                      <span className="ppt-meta-text">Registered Leads:</span>
                                    </div>
                                    <div className="ppt-meta-right">
                                      <span className="ppt-meta-value">{propType.registered_leads || 0}</span>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Pagination (EXACT React Native app logic) */}
                  {totalPages > 1 && (
                    <div className="ppt-pagination">
                      <button
                        className={`ppt-page-btn ${page <= 1 ? 'disabled' : ''}`}
                        onClick={async () => {
                          if (page > 1 && !loading) {
                            setLoading(true);
                            try {
                              await loadPropertyTypes(page - 1);
                            } finally {
                              setLoading(false);
                            }
                          }
                        }}
                        disabled={page <= 1 || loading}
                      >
                        ← Previous
                      </button>

                      <span className="ppt-page-info">
                        Page {page} of {totalPages} ({total} total)
                      </span>

                      <button
                        className={`ppt-page-btn ${page >= totalPages ? 'disabled' : ''}`}
                        onClick={async () => {
                          if (page < totalPages && !loading) {
                            setLoading(true);
                            try {
                              await loadPropertyTypes(page + 1);
                            } finally {
                              setLoading(false);
                            }
                          }
                        }}
                        disabled={page >= totalPages || loading}
                      >
                        Next →
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}